export default __webpack_public_path__ + "static/media/clearFilters.d280f411.svg";